import score from '@/api/student-scoring-entry'
import classOperation from '@/api/class-operation'
import Enrollment from '@/api/student-enrollment'
import AssessmentDetail from '@/api/score-assessment-detail-component'
import grading from '@/api/grading-definition'
import acYear from '@/api/academic-year'
import mainProgram from '@/api/main-program'
import acTerm from '@/api/term-semester'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  scoring_cycle_id: null,
  ac_year_id: null,
  branch_id: [],
  acp_id: null,
  ac_term_id: null,
  scoring_cycles: [],
  scoring_cycle_values: [],
  ac_status_id: 1
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_SCORING_CYCLE_ID(state, id) {
    state.scoring_cycle_id = id
  },
  SET_BRANCH_LIST(state, branch_id) {
    state.branch_id = branch_id
  },
  SET_AC_YEAR_ID(state, ac_year_id) {
    state.ac_year_id = ac_year_id
  },
  SET_MAIN_PROGRAM(state, acp_id) {
    state.acp_id = acp_id
  },
  SET_AC_TERM_ID(state, ac_term_id) {
    state.ac_term_id = ac_term_id
  },
  SET_SCORING_CYCLES(state, data) {
    state.scoring_cycles = data
  },
  SET_SCORING_CYCLE_VALUES(state, data) {
    state.scoring_cycle_values = data
  },
  SET_AC_STATUS(state, acStatusId) {
    state.ac_status_id = acStatusId
  },
  RESET_FILTER(state) {
    ;(state.scoring_cycle_id = null),
      (state.ac_year_id = null),
      (state.branch_id = []),
      (state.acp_id = null),
      (state.ac_term_id = null)
  }
}

export const actions = {
         fetch(context, attributes = {}) {
           const params = Object.assign(
             {
               page: context.state.pagination.page,
               perPage: context.state.pagination.perPage,
               search: context.state.search,
               scoring_cycle_id: context.state.scoring_cycle_id,
               branch_id: context.state.branch_id,
               ac_year_id: context.state.ac_year_id,
               acp_id: context.state.acp_id,
               ac_term_id: context.state.ac_term_id
             },
             attributes
           )

           return score.get({ params }).then(response => {
             context.commit('RECEIVE_RESOURCES', response)
             return Promise.resolve(response)
           })
         },

         store(context, data) {
           return score.store(data)
         },

         async find(context, params) {
           if (_.isEmpty(context.state.edit_data)) {
             let response = await score.find(params.student_id, {
               params: params
             })
             context.commit('SET_EDIT_DATA', response.data)
           }
         },
         async findScoring(context, params) {
           return await score.findScoring(params.student_id, { params: params })
         },
         findScoreAssementDetail(
           context,
           { sc_setup_id, program_structure_id }
         ) {
           return AssessmentDetail.find(sc_setup_id, {
             params: { program_structure_id: program_structure_id }
           })
         },
         getComponent(context, { sc_setup_id, program_structure_id }) {
           return AssessmentDetail.getComponent(
             sc_setup_id,
             program_structure_id
           )
         },
         getComponents(context, params) {
           return AssessmentDetail.getComponents(
             params.sc_setup_id,
             params.program_structure_id,
             params.acps_id
           )
         },
         getGradingDefinition(context) {
           return grading.get({
             params: {
               page: -1
             }
           })
         },
         getProgramStructure(context, { student_id, class_id }) {
           return score.getProgramStructure(student_id, class_id)
         },
         getStudentEnrollmentByClass(context, class_id) {
           return Enrollment.get({
             params: {
               filter: {
                 class_id: class_id
               },
               page: -1
             }
           })
         },
         getClassOperation(context) {
           return classOperation.get({
             params: {
               include: 'main_program,academic_year,academic_term,teacher',
               fields: {
                 academic_classes:
                   'class_id,class_name,acp_id,acps_id,ac_year_id,ac_term_id,teacher_resp_id,class_desc,ac_category_id',
                 main_program: 'acp_id,acp_name_foreign',
                 academic_term: 'ac_term_id,term_name,term_order',
                 academic_year: 'ac_year_id,ac_year',
                 teacher: 'teacher_id,fname_foreign,lname_foreign'
               },
               filter: {
                 ac_status_id: context.state.ac_status_id
               },
               page: -1
             },
             header: {
               'X-PERMISSION-ALLOW-CODE':
                 context.rootGetters.permissionAllowCode
             }
           })
         },
         saveComment(context, data) {
           return score.saveComment(data)
         },
         updateComment(context, data) {
           return score.updateComment(data)
         },
         findComment(context, { params }) {
           return score.findComment({
             params: params
           })
         },
         getGradingComponent(context, { grade_id, sc_bas_id, acps_id }) {
           return score.getGradingComponent(grade_id, sc_bas_id, acps_id)
         },
         async getScoringCycle(context, params) {
           let response = await score.getScoringCycle({
             params: params
           })
           context.commit('SET_SCORING_CYCLES', response.data)
         },
         async getScoringCycleValue(context) {
           let response = await score.getScoringCycleValue()
           context.commit('SET_SCORING_CYCLE_VALUES', response.data)
         },
         getAvgScore(context, { params }) {
           return score.getAvgScore(params.student_id, {
             params: params
           })
         },
         getAvgScoreBySubject(context, { params }) {
           return score.getAvgScoreBySubject(params.student_id, {
             params: params
           })
         },
         getLearingExpectationSubject(context, { grade_id, term_order }) {
           return AssessmentDetail.getLearingExpectationSubject(
             grade_id,
             term_order
           )
         },
         saveDayAbsent(context, data) {
           return score.saveDayAbsent(data)
         },
         // Get Academic Year
         getAcYear(context) {
           return acYear.get({
             params: {
               fields: {
                 academic_years: 'ac_year_id,ac_year'
               },
               page: -1
             },
             header: {
               'X-PERMISSION-ALLOW-CODE':
                 context.rootGetters.permissionAllowCode
             }
           })
         },
         getMainProgram(context) {
           return mainProgram.get({
             params: {
               fields: {
                 academic_program_mains: 'acp_id,acp_name_foreign'
               },
               page: -1
             },
             header: {
               'X-PERMISSION-ALLOW-CODE':
                 context.rootGetters.permissionAllowCode
             }
           })
         },
         getAcTerm(context) {
           return acTerm.get({
             params: {
               include: 'sub_program',
               fields: {
                 academic_terms: 'ac_term_id,term_name,ac_status_id,acps_id'
               },
               filter: {
                 ac_year_id: context.state.ac_year_id
               },
               page: -1
             },
             header: {
               'X-PERMISSION-ALLOW-CODE':
                 context.rootGetters.permissionAllowCode
             }
           })
         },
         getComment(context, data) {
           return score.getComment(data)
         },
         getTermByMainProgram(context, { ac_year_id, acp_id }) {
           return acTerm.get({
             params: {
               fields: {
                 academic_terms: 'ac_term_id,term_name,ac_status_id'
               },
               filter: {
                 ac_year_id: ac_year_id,
                 by_main_program: acp_id,
                 ac_status_id: 2
               },
               page: -1
             },
             header: {
               'X-PERMISSION-ALLOW-CODE':
                 context.rootGetters.permissionAllowCode
             }
           })
         },
         getScoreFromAttendance(context, { params }) {
           return score.getScoreFromAttendance(params.student_id, {
             params: params
           })
         },
         saveRatingScale(context, data) {
           return score.storeRatingScale(data)
         },
         findRatingScal(context, { params }) {
           return score.findRatingScal({
             params: params
           })
         },
         updateRatingScale(context, data) {
           return score.updateRatingScale(data)
         }
       }
